import { MULTI_DEPOSIT_LIMIT_ACTION_TYPE } from "./multi-deposit-limit.action";

export const MULTI_DEPOSIT_LIMIT_MESSAGE_CONTEXT = {
	get: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.get,
	update: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.update,
};

export const MULTI_DEPOSIT_LIMIT_MESSAGE_CODES = {
	updateSuccess: "M_MULTI_DEPOSIT_LIMIT_UPDATE_SUCCESS",
	error: "E_MULTI_DEPOSIT_LIMIT",
	limitNotFound: "E_DEPOSITLIMIT_LIMITWITHTYPENOTFOUND",
};
